import { unstable_serialize } from 'swr';
const retryState = new Map();
export const withRetryStatus = (useSWRNext) => (key, fetcher, config) => {
    const swr = useSWRNext(key, fetcher, {
        ...config,
        onError: (error, errorKey, errorConfig) => {
            const state = retryState.get(errorKey) ?? {
                attempts: 0,
                exhausted: false,
            };
            state.attempts += 1;
            const retryEnabled = typeof errorConfig.shouldRetryOnError === 'function'
                ? errorConfig.shouldRetryOnError(error)
                : (errorConfig.shouldRetryOnError ?? true);
            const maxRetries = errorConfig.errorRetryCount ?? Number.POSITIVE_INFINITY;
            state.exhausted = !retryEnabled || state.attempts > maxRetries;
            retryState.set(errorKey, state);
            config.onError?.(error, errorKey, errorConfig);
        },
        onSuccess: (data, successKey, successConfig) => {
            retryState.delete(successKey);
            config.onSuccess?.(data, successKey, successConfig);
        },
    });
    const exhausted = retryState.get(unstable_serialize(key))?.exhausted === true;
    const isRetrying = swr.error !== undefined && !exhausted;
    const isTerminalError = swr.error !== undefined && exhausted;
    const isLoading = isTerminalError
        ? false
        : swr.isLoading || (isRetrying && swr.data === undefined);
    return { ...swr, isRetrying, isTerminalError, isLoading };
};
